import React from 'react';
import {
  FilePdfFilled,
  FilePdfOutlined,
  FolderFilled,
  FolderOpenFilled,
  FileTextFilled,
  FileWordFilled,
  FileExcelFilled,
  FilePptFilled,
  FileImageFilled,
  FileZipFilled,
  PlayCircleFilled,
  PlaySquareFilled,
  FileOutlined,
  FileFilled,
  UnlockOutlined,
  LockOutlined

} from '@ant-design/icons'

const getFileExtension = (filename) => {
  return (filename || '').split('.').pop().toLowerCase();
}

export const FileIcon = ({
  isFolder,
  size = 18,
  title,
  ischecked
}) => {
  if (isFolder) {
    return <FolderFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#eabf45' }} />
  }

  const ext = getFileExtension(title)
  switch (ext) {
    case 'txt':
      return <FileTextFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'doc':
    case 'docx':
      return <FileWordFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'xlsx':
    case 'xls':
      return <FileExcelFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'png':
    case 'gif':
    case 'webp':
    case 'jpg':
    case 'jpeg':
    case 'bmp':
    case 'ppt':
    case 'pptx':
      return <FileImageFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'ppt':
      return <FilePptFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'wav':
    case 'mp3':
      return <PlayCircleFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'flv':
    case 'rmvb':
    case 'wmv':
      return <PlaySquareFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'rar':
    case 'zip':
    case '7z':
      return <FileZipFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
    case 'pdf':
      return <FilePdfFilled style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />

    default:
      return <FileOutlined style={{ fontSize: size, color: ischecked ? '#fff' : '#1c578f' }} />
  }
}

export const FolderIcon = ({ isOpen, size = 20, isSystem, ischecked }) => {
  let Icon;
  if (isSystem) {
    Icon = isOpen ? UnlockOutlined : LockOutlined;
  } else {
    Icon = isOpen ? FolderOpenFilled : FolderFilled;
  }
  return <Icon style={{ fontSize: size, color: ischecked ? '#fff' : '#eabf45' }} />
}


